module.exports = "/assets/data/926daa2d5595d5c290e32cb97f827e19-DN3.data.json";